export default {
  extraLarge2: 'xlarge2',
  extraLarge1: 'xlarge1',
  large2: 'large2',
  large1: 'large1',
  medium: 'medium1',
  body: 'bodyText',
  small: 'small',
  extraSmall: 'xsmall',
};
